<template>
  <section
    class="bg-gray-800 bg-no-repeat bg-cover bg-center select-none h-72"
    :style="backgroundImage(course?.file?.url)"
  >
    <div
      class="px-8 grid grid-cols-12 gap-5 py-8 h-full items-center container mx-auto"
    >
      <div
        class="col-span-12 md:col-span-6 text-center md:text-start text-white"
      >
        <h5 class="mb-3 flex items-center gap-5">
          {{ course?.name }}
          <Button
            v-if="role == 'TEACHER'"
            class="btn-outline-white p-button-sm h-10"
            @click="go.redirectToPage('formCourse', { id: course?.id })"
          >
            <v-icon
              name="hi-solid-pencil"
              class="cursor-pointer hover:scale-125 transition-all"
            />
            <p class="ml-2">
              {{
                $t("labels.generic", {
                  pt: "Editar",
                  en: "Edit",
                })
              }}
            </p>
          </Button>
        </h5>
        <p class="text-md mb-3 text-gray-300">{{ course?.description }}</p>
        <div
          v-if="user.teacherProfile === null && role == 'TEACHER'"
          class="bg-h-warning-100 text-h-warning-700 rounded-md shadow-sm flex gap-2 p-2 mt-5 w-fit"
        >
          <v-icon name="md-warningamber-round" />
          <p>
            {{
              $t("labels.generic", {
                pt: "Lembre-se de adicionar a sua biografia e os seus títulos,",
                en: "Remember to add your biography and titles,",
              })
            }}
            <router-link :to="{ name: 'editUser' }" class="font-bold">
              {{
                $t("labels.generic", { pt: "clique aqui.", en: "click here." })
              }}
            </router-link>
          </p>
        </div>
      </div>
      <div class="col-span-12 md:col-span-6">
        <div class="hidden justify-center md:justify-end">
          <Button
            v-if="course?.status == 'APPROVED'"
            label="Publicar curso"
            class="btn-primary p-button-sm"
            @click="courseGenerics.publishCourse(course?.id)"
          />
          <Button
            v-if="course?.status == 'NOT_PUBLISHED'"
            label="Enviar para aprovação"
            class="btn-light p-button-sm"
            @click="
              courseGenerics.sendToApprove(
                course?.id,
                course.type === 'INTERACTIVE' ? '/api' : '/graphs'
              )
            "
          />
          <Button
            v-if="course?.status == 'WAITING'"
            label="Aguardando aprovação"
            class="btn-outline p-button-sm"
            :disabled="true"
          />
        </div>
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import { CoursesGenerics } from "@/utils/courses.util";
import { GoToRoute } from "@/utils/go-to.util";
import { getUserFromStorage } from "@/utils/user-store.util";
import { EditUserService } from "@/views/EditUser/edit-user.service";
import { defineComponent } from "vue";

export default defineComponent({
  name: "heroChapters",
  computed: {
    courseGenerics(): CoursesGenerics {
      return new CoursesGenerics();
    },
    go(): GoToRoute {
      return new GoToRoute();
    },
    service(): EditUserService {
      return new EditUserService();
    },
    userFromStorage(): any {
      return getUserFromStorage();
    },
  },
  data() {
    return {
      emptyImg:
        "https://video-thumb.s3.sa-east-1.amazonaws.com/65197bdbplaceholder.png" as string,
      user: {} as any,
    };
  },
  props: {
    course: [Object],
    role: [String],
  },
  mounted() {
    this.getProfileUser();
  },
  methods: {
    backgroundImage(image: string): any {
      return {
        "background-image": `linear-gradient(
              to bottom right,
              rgba(0, 0, 0, 0.5),
              #353535 90%
            ),url(${image})`,
      };
    },
    getProfileUser(): void {
      this.service.profile.subscribe({
        next: (response) => {
          this.user = response;
        },
      });
      this.service.getProfileUser();
    },
  },
});
</script>
